import PropTypes from 'prop-types';

export const ImageModelPropTypes = PropTypes.shape({
  FinalSrc: PropTypes.string,
  Src: PropTypes.string,
  Width: PropTypes.number,
  Height: PropTypes.number,
  CropSettings: PropTypes.shape({
    SourceX: PropTypes.number,
    SourceY: PropTypes.number,
    SourceWidth: PropTypes.number,
    SourceHeight: PropTypes.number,
  }),
  IsIncluded: PropTypes.bool,
});
